import { createSlice } from "@reduxjs/toolkit";

const permissionGridSlice = createSlice({
  name: "permissionGridSlice",
  initialState: {
    selectedId: null,
  },
  reducers: {
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    clearSelectedId: (state) => {
      state.selectedId = null;
    },
  },
});

export const { setSelectedId, clearSelectedId } = permissionGridSlice.actions;
export const permissionGridReducer = permissionGridSlice.reducer;
